import { render, staticRenderFns } from "./ConcernPerson.vue?vue&type=template&id=44d2ef67&scoped=true"
import script from "./ConcernPerson.vue?vue&type=script&lang=js"
export * from "./ConcernPerson.vue?vue&type=script&lang=js"
import style0 from "./ConcernPerson.vue?vue&type=style&index=0&id=44d2ef67&prod&lang=scss&scoped=true"
import style1 from "./ConcernPerson.vue?vue&type=style&index=1&id=44d2ef67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2ef67",
  null
  
)

export default component.exports